import type { UserGroupsLocale } from './en'

export const userGroupsEs = {
  common: {
    cancel: `Cancelar`,
    close: `Cerrar`,
    delete: `Eliminar`,
    error: `Error`,
    yes: `Sí`,
    no: `No`,
    requirePin: `Requerir PIN`,
    pin: `PIN`,
    auto: `auto`,
  },
  list: {
    title: `Grupos de usuarios`,
    searchPlaceholder: `Buscar por nombre o miembro...`,
    searchAriaLabel: `Buscar grupos de usuarios`,
    createNew: `Nuevo grupo de usuarios`,
    createNewAriaLabel: `Crear nuevo grupo de usuarios`,
    tableAriaLabel: `Tabla de grupos de usuarios`,
    loading: `Cargando grupos de usuarios...`,
    noResultsTitle: `No se encontraron resultados`,
    noResultsDescription: `Intenta ajustar los términos de búsqueda`,
    emptyTitle: `Aún no hay grupos de usuarios`,
    emptyDescription: `Comienza creando tu primer grupo de usuarios`,
    autoGeneratedDeleteTooltip: `Los grupos generados automáticamente no se pueden eliminar`,
    truncatedWarning: `Mostrando los primeros {{shown}} de {{total}} grupos de usuarios. Algunos grupos no aparecen en la lista; comuníquese con soporte.`,
    actionsForGroup: `Acciones para {{name}}`,
    editGroup: `Editar {{name}}`,
    deleteGroup: `Eliminar {{name}}`,
    deleteGroupDisabled: `Eliminar {{name}} (deshabilitado)`,
    accessAria: `{{label}}: {{status}}`,
    column: {
      name: `Nombre`,
      members: `Miembros`,
      internal: `Interno`,
      local: `Local`,
      longDistance: `Larga dist.`,
      domesticLongDistance: `Larga distancia`,
      international: `Internacional`,
      action: `Acción`,
    },
    pagination: {
      perPage: `Por página:`,
      total: `({{count}} en total)`,
      resultsPerPage: `Resultados por página`,
      previousPage: `Página anterior`,
      nextPage: `Página siguiente`,
      jumpToPage: `Ir a la página {{page}}`,
      morePages: `Más páginas`,
    },
    deleteDialog: {
      title: `Eliminar grupo de usuarios`,
      description: `¿Seguro que deseas eliminar "{{name}}"? Esto quitará todas las asociaciones de miembros y no se puede deshacer.`,
      successTitle: `Grupo de usuarios eliminado`,
      successDescription: `"{{name}}" se eliminó.`,
      alreadyDeletedTitle: `Ya se eliminó`,
      alreadyDeletedDescription: `No se encontró este grupo de usuarios; puede que ya se haya eliminado.`,
      failedDescription: `No se pudo eliminar el grupo de usuarios.`,
    },
  },
  form: {
    addTitle: `Agregar grupo de usuarios`,
    editTitle: `Editar grupo de usuarios`,
    loading: `Cargando grupo de usuarios...`,
    loadingError: `Error al cargar el grupo de usuarios: {{message}}`,
    autoGeneratedNotice: `Grupo generado automáticamente: algunos campos están restringidos.`,
    nameLabel: `Nombre`,
    namePlaceholder: `Ingresa el nombre del grupo`,
    nameRequired: `El nombre es obligatorio.`,
    nameMaxLength: `El nombre debe tener 64 caracteres o menos.`,
    accessPermissions: `Permisos de acceso`,
    members: `Miembros`,
    createUserGroup: `Crear grupo de usuarios`,
    saveChanges: `Guardar cambios`,
    access: {
      internal: `Interno`,
      local: `Local`,
      domesticLongDistance: `Larga distancia nacional`,
      international: `Internacional`,
      tollNumbers: `Números con cargo`,
      maliciousAreaCodes: `Códigos de área maliciosos`,
      superAccess: `Acceso superior`,
      eavesdropping: `Escucha`,
      promptRecording: `Grabación de mensajes`,
    },
    memberPicker: {
      placeholder: `Seleccionar miembros...`,
      searchPlaceholder: `Filtrar miembros...`,
      emptyLabel: `No hay usuarios asignados a este PBX.`,
      noResultsLabel: `Ningún usuario coincide con tu filtro.`,
      summary_one: `{{count}} miembro seleccionado`,
      summary_other: `{{count}} miembros seleccionados`,
    },
  },
  toast: {
    createdTitle: `Grupo de usuarios creado`,
    updatedTitle: `Grupo de usuarios actualizado`,
    authRequiredTitle: `Autenticación requerida`,
    authRequiredDescription: `Es posible que tu sesión haya expirado. Vuelve a autenticarte e inténtalo de nuevo.`,
    createFailedTitle: `No se pudo crear el grupo de usuarios`,
    updateFailedTitle: `No se pudo actualizar el grupo de usuarios`,
  },
} satisfies UserGroupsLocale
